import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n'
import App from './App.tsx'

// Nothing in this bundle writes 'toyama:spa-redirect' — the generated 404.html
// does, because GitHub Pages cannot rewrite deep links to the shell. Restore the
// parked path before the router reads window.location.
try {
  const pending = sessionStorage.getItem('toyama:spa-redirect')
  if (pending) {
    sessionStorage.removeItem('toyama:spa-redirect')
    history.replaceState(null, '', pending)
  }
} catch {
  // Private browsing blocks storage; the shell still boots at the base.
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
